export default {"src":"/_next/static/media/4.d6a78ce9.svg","height":69,"width":94,"blurWidth":0,"blurHeight":0};